import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

type CardProps = {
  image: string;
};

type ShowTourProps = {
  showTour: false;
};

export const ContentWrap = styled.div`
  position: relative;
  grid-area: ctos;
  display: flex;
  flex-direction: column;
  gap: 15px;
  background-color: #ffff;
  padding: 2px;
  border-radius: 8px;
`;

export const ContentCard = styled.div<ShowTourProps>`
  height: 100%;
  width: 100%;
  grid-area: ctos;
  display: flex;
  flex-direction: column;
  gap: 15px;

  ${({ showTour }) =>
    showTour &&
    css`
      position: relative;
      z-index: 1000;
    `}
`;

export const Card = styled.div<CardProps>`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 15px;
  gap: 15px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme?.colors?.blue};
  background-image: ${({ image }) => `url(${image})`};
`;

export const Icon = styled.div`
  & svg {
    font-size: 25px;
    color: #fff;
  }
`;

export const Title = styled.span`
  font-size: 16;
  line-height: 16px;
  font-weight: 700;
  color: #fff;
  width: 100px;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
`;

export const Button = styled(Link)`
  position: absolute;
  bottom: 15px;
  right: 15px;
  padding: 10px 10px;
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 1;
  background-color: ${({ theme }) => theme.colors.blue};
  color: #fff;
  border-radius: 4px;

  &:hover {
    text-decoration: none;
    color: #fff;
  }

  & svg {
    margin-left: 5px;
    font-size: 16px;
  }
`;
